"use client";

import React, { useRef, useEffect } from "react";

interface OutsideAlerterProps {
	children: React.ReactNode;
	className?: string;
	onClick(): void;
}

/**
 * Component that calls the passed onClick function if you click outside of it.
 */
export default function OutsideAlerter(props: OutsideAlerterProps) {
	const wrapperRef = useRef(null);

	useOutsideAlerter(wrapperRef, props.onClick);

	return (
		<div ref={wrapperRef} className={props.className}>
			{props.children}
		</div>
	);
}

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(ref: any, onClick: Function) {
	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(event: MouseEvent) {
			if (ref.current && !ref.current.contains(event.target) && onClick) {
				onClick();
			}
		}

		// Bind the event listener
		document.addEventListener("pointerdown", handleClickOutside);

		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("pointerdown", handleClickOutside);
		};
	}, [onClick, ref]);
}
